import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import LessonsApi from '../generated/api/Lessons';

export default (service: Servicelayer) => ({
  ...LessonsApi(service),

  // Add custom calls here

});
